import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './translations/en/common.json';
import enNavigation from './translations/en/navigation.json';
import enErrors from './translations/en/errors.json';
import enWorkOrders from './translations/en/workOrders.json';
import enWorkOrderDetails from './translations/en/workOrderDetails.json';
import enChecklist from './translations/en/checklist.json';
import enSettings from './translations/en/settings.json';
import enCalibration from './translations/en/calibration.json';
import enCalibrationApi from './translations/en/calibrationApi.json';
import enSidebar from './translations/en/sidebar.json';
import enParts from './translations/en/parts.json';
import enCharges from './translations/en/charges.json';
import enCustomerReview from './translations/en/customerReview.json';
import enHistory from './translations/en/history.json';

const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    errors: enErrors,
    workOrders: enWorkOrders,
    workOrderDetails: enWorkOrderDetails,
    checklist: enChecklist,
    settings: enSettings,
    calibration: enCalibration,
    calibrationApi: enCalibrationApi,
    sidebar: enSidebar,
    parts: enParts,
    charges: enCharges,
    customerReview: enCustomerReview,
    history: enHistory
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: [
    'common',
    'navigation',
    'errors',
    'workOrders',
    'workOrderDetails',
    'checklist',
    'settings',
    'calibration',
    'calibrationApi',
    'sidebar',
    'parts',
    'charges',
    'customerReview',
    'history'
  ],
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
